export default __webpack_public_path__ + "static/media/6-min.606046a0.jpg";